import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AsyncDisplay from 'js/components/Loading/AsyncDisplay';
import LoadingMessage from 'js/components/Loading/LoadingMessage';

function chartItemKey(chart, index) {
  return chart.key || chart.buttonProps?.['data-chart-type'] || String(index);
}

const ChartSelector = ({
  charts,
  className,
  loading,
  error,
  activeKey = null,
  onChange = null,
  ...props
}) => {
  const [uncontrolledIndex, setUncontrolledIndex] = useState(0);
  const isControlled = typeof onChange === 'function';
  const keyedIndex = charts.findIndex(
    (chart, index) => chartItemKey(chart, index) === activeKey
  );
  const chartIndex = isControlled
    ? keyedIndex >= 0
      ? keyedIndex
      : 0
    : uncontrolledIndex;
  const selected = charts[chartIndex] ?? charts[0];

  if (!selected) {
    return null;
  }

  const { component: ChartComponent, componentProps = {} } = selected;

  return (
    <>
      <div className={classnames('switch-menu', className)}>
        {charts.map((chart, i) => (
          <button
            {...chart.buttonProps}
            key={chartItemKey(chart, i)}
            onClick={(e) => {
              e.preventDefault();
              if (isControlled) {
                onChange(chartItemKey(chart, i));
              } else {
                setUncontrolledIndex(i);
              }
            }}
            className={classnames({
              'switch-menu-item': true,
              active:
                chartItemKey(chart, i) === chartItemKey(selected, chartIndex),
            })}
          >
            {chart.label}
          </button>
        ))}
      </div>
      <AsyncDisplay isLoading={!!loading} isError={!!error}>
        <AsyncDisplay.Loading>
          <LoadingMessage iconSize="2x">Loading data&hellip;</LoadingMessage>
        </AsyncDisplay.Loading>
        <AsyncDisplay.Error>
          <div className="danger">
            Uh oh, looks like there was a problem loading the data
          </div>
        </AsyncDisplay.Error>
        <AsyncDisplay.Resolved>
          <ChartComponent {...props} {...componentProps} />
        </AsyncDisplay.Resolved>
      </AsyncDisplay>
    </>
  );
};

ChartSelector.propTypes = {
  charts: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
      component: PropTypes.elementType.isRequired,
    })
  ),
  activeKey: PropTypes.string,
  onChange: PropTypes.func,
};

export default ChartSelector;
